import { ProtonColorScale, ProtonPalette } from "./types";

/* Base Colors */

export const BACKGROUNDS = {
  BLACK: "#121212",
  WHITE: "#FFFFFF",
};

export const BRAND: ProtonPalette["BRAND"] = {
  PRIMARY: "#E26014",
  PRIMARY_LIGHT: "#FBE5D7",
  PRIMARY_SUPER_LIGHT: "#FFF7F0",
  SECONDARY: "#2a9edb",
  SECONDARY_LIGHT: "#b5d9ff",
  SECONDARY_SUPER_LIGHT: "#d9e7fa",
};

export const BRAND_PRIMARY_SCALE: ProtonColorScale = {
  SUPER_DARK: "#2d1304",
  DARK: "#5a2608",
  MEDIUM: "#883a0c",
  MEDIUM_LIGHT: "#b54d10",
  LIGHT: "#e88043",
  LIGHTEST: "#eea072",
  SUPER_LIGHT: "#f9dfd0",
  WHITE: "#fcfbfa",
};

/* Semantic Colors */

export const DANGER: Partial<ProtonColorScale> = {
  SUPER_DARK: "#991b1b",
  DARK: "#a80724",
  MEDIUM: "#e23f5c",
  LIGHT: "#f16880",
  SUPER_LIGHT: "#ffe1e1",
};

export const WARNING: Partial<ProtonColorScale> = {
  DARK: "#8b5600",
  MEDIUM: "#b37208",
  LIGHT: "#ffac23",
  SUPER_LIGHT: "#fff0c9",
};

export const SUCCESS: Partial<ProtonColorScale> = {
  DARK: "#247800",
  MEDIUM: "#339a07",
  LIGHT: "#66cf39",
  SUPER_LIGHT: "#deffd1",
};
